import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Typography, TextField, Button, Paper, CircularProgress,
} from "@mui/material";
import { Login as LoginIcon } from "@mui/icons-material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EmployeeLogin } from "../../../../Services/Services";

function EmployeeLoginComponent() {
  const navigate = useNavigate();
  const [uniqueId, setUniqueId] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (localStorage.getItem("emp_logged_in") === "true") {
      navigate("/employee-dashboard", { replace: true });
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!uniqueId.trim() || !password.trim()) {
      setError("Employee ID and Password required");
      toast.error("Employee ID and Password required");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await EmployeeLogin({
        unique_id: uniqueId.trim().toUpperCase(),
        password: password,
      });

      if (response.success) {
        const empId = String(response.id || "");
        const profileId = String(response.profile_id || response.id || "");

        localStorage.setItem("emp_logged_in", "true");
        localStorage.setItem("emp_id", empId);
        localStorage.setItem("emp_name", response.name || "");
        localStorage.setItem("emp_unique_id", response.unique_id || "");
        localStorage.setItem("emp_profile_id", profileId);
        localStorage.setItem("emp_qr_token", response.qr_token || "");

        toast.success("Login successful! Welcome " + response.name);
        navigate("/employee-dashboard", { replace: true });
      } else {
        setError(response.message || "Login failed");
        toast.error(response.message || "Login failed");
      }
    } catch (err) {
      const msg = err.response?.data?.message || err.response?.data?.error || "Login failed";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "#FCF5EB", p: 2 }}>
        <Paper component="form" onSubmit={handleLogin}
          sx={{ maxWidth: 380, width: "100%", p: 4, borderRadius: "16px", boxShadow: "0 8px 32px rgba(0,0,0,0.12)", textAlign: "center" }}>
          <Typography sx={{ fontSize: "48px", mb: 1 }}>🏢</Typography>
          <Typography sx={{ fontSize: "22px", fontWeight: 700, color: "#1e293b", mb: 0.5 }}>Employee Login Cranoist</Typography>
          <Typography sx={{ fontSize: "13px", color: "#64748b", mb: 3 }}>Enter your Employee ID to continue</Typography>

          {error && (
            <Box sx={{ p: 1.5, bgcolor: "#fee2e2", borderRadius: "8px", mb: 2 }}>
              <Typography sx={{ fontSize: "13px", color: "#dc2626", fontWeight: 500 }}>{error}</Typography>
            </Box>
          )}

          <TextField fullWidth label="Employee ID" placeholder="e.g., EMP0001" value={uniqueId}
            onChange={(e) => setUniqueId(e.target.value.toUpperCase())}
            sx={{ mb: 2, "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { borderColor: "#ff8800" } }, "& .MuiInputLabel-root.Mui-focused": { color: "#ff8800" } }}
            InputProps={{ sx: { fontSize: "16px", fontWeight: 600, letterSpacing: "1px" } }}
          />

          <TextField fullWidth type="password" label="Password" placeholder="Enter password" value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ mb: 3, "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { borderColor: "#ff8800" } }, "& .MuiInputLabel-root.Mui-focused": { color: "#ff8800" } }}
          />

          <Button type="submit" fullWidth disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : <LoginIcon />}
            sx={{ bgcolor: "#ff8800", color: "#fff", py: 1.5, fontSize: "15px", fontWeight: 600, textTransform: "none", borderRadius: "10px", "&:hover": { bgcolor: "#e67a00" } }}>
            {loading ? "Logging in..." : "Login"}
          </Button>

          <Typography sx={{ fontSize: "10px", color: "#94a3b8", mt: 3 }}>Cranoist Attendance System</Typography>
        </Paper>
      </Box>
    </>
  );
}

export default EmployeeLoginComponent;